import { z } from 'zod';
/**
 * Zod-схемы для платежей — ПП РФ № 1317 п.3 и).
 *
 * Источников два:
 *  - MANUAL — ручной ввод менеджером в кабинете (этап 7).
 *  - ONEC_PUSH — push из 1С через ingestion API с идемпотентностью по oneCExternalId
 *    (этап 8).
 *
 * На этапе 7 реализуется только MANUAL.
 */
export const paymentMethodSchema = z.enum(['BANK_TRANSFER', 'CARD', 'CASH', 'OTHER']);
/**
 * Создание платежа.
 *
 * Инвариант: хотя бы одно из `shipmentId` / `orderId` должно быть указано
 * (платёж всегда привязан к чему-то). Проверка через `superRefine`.
 */
export const paymentCreateSchema = z
    .object({
    shipmentId: z.string().optional(),
    orderId: z.string().optional(),
    amount: z.number().positive(),
    currency: z
        .string()
        .length(3)
        .regex(/^[A-Z]{3}$/, 'currency — 3-х буквенный ISO 4217 код'),
    method: paymentMethodSchema,
    /** Свободный текст: назначение платежа. */
    purpose: z.string().min(1).max(500),
    /** Плательщик/получатель (свободный текст). */
    counterpartyName: z.string().max(500).optional(),
    /** Идентификатор в платёжной системе (банковский референс, ID транзакции). */
    paymentSystemId: z.string().max(200).optional(),
    /** Дата операции (ISO datetime). */
    occurredAt: z.string().datetime(),
    /** Прочие технические данные операции. */
    meta: z.record(z.unknown()).optional(),
})
    .superRefine((v, ctx) => {
    if (!v.shipmentId && !v.orderId) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Платёж должен быть привязан к shipment или order',
            path: ['shipmentId'],
        });
    }
});
/** Правка платежа — то же самое без shipmentId/orderId (привязку менять нельзя). */
export const paymentPatchSchema = z.object({
    amount: z.number().positive().optional(),
    currency: z
        .string()
        .length(3)
        .regex(/^[A-Z]{3}$/)
        .optional(),
    method: paymentMethodSchema.optional(),
    purpose: z.string().min(1).max(500).optional(),
    counterpartyName: z.string().max(500).optional(),
    paymentSystemId: z.string().max(200).optional(),
    occurredAt: z.string().datetime().optional(),
    meta: z.record(z.unknown()).optional(),
});
export const paymentDtoSchema = z.object({
    id: z.string(),
    shipmentId: z.string().nullable(),
    orderId: z.string().nullable(),
    amount: z.number(),
    currency: z.string(),
    method: paymentMethodSchema,
    purpose: z.string(),
    counterpartyName: z.string().nullable(),
    paymentSystemId: z.string().nullable(),
    occurredAt: z.string().datetime(),
    source: z.string(),
    oneCExternalId: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=payments.js.map